export default {
  state: {
    ZoneDatas: []
  },
  getters: {
    ZoneDatas(state) {
      return state.ZoneDatas;
    }
  },
  mutations: {
    setZoneDatas(state, ZoneDatas) {
      state.ZoneDatas = ZoneDatas;
    }
  },
  actions: {
    setZoneDatas({
      commit
    }, ZoneDatas) {
      commit('setZoneDatas', ZoneDatas)
    }
  }
  // action: {
  //   setAreas({
  //     commit
  //   }) {
  //     commit('setAreas')
  //   }
  // },
}



// WEBPACK FOOTER //
// ./src/store/ZoneStore.js